import { Component, Input, OnDestroy, OnInit } from "@angular/core"
import { Subscription } from "rxjs"
import { StandardsInformation } from "../../../models/resource/standards"
import { LocalizationService } from "../../../services/localization.service"
import { UserService } from "../../../services/user.service"
import { ModalService } from "../../../shared-components/modal/modal.service"
import { AuthModalComponent } from "../../../shared-components/modals/auth-modal/auth-modal.component"
import { LocalizationModalComponent } from "../../../shared-components/modals/localization-modal/localization-modal.component"
import { AddOnViewService } from "../../../services/add-on-view.service"
import { StandardsService } from "../../../services/standards.service"

@Component({
    selector: "app-standards-section",
    templateUrl: "./standards-section.component.html",
    styleUrls: ["./standards-section.component.scss"],
    standalone: false,
})
export class StandardsSectionComponent implements OnInit, OnDestroy {
    @Input() public standardsInformation: StandardsInformation = null

    subscriptions: Subscription[] = []
    nationalStandards: any = []
    primaryStateStandardsName: string = ""
    primaryStateStandards: any = []
    secondaryStateStandardsName: string = ""
    secondaryStateStandards: any = []
    isUserLoggedIn: boolean = false
    isUserLocalized: boolean = false
    stateStandards: string = ""
    hasStateStandards: boolean = false

    constructor(
        private userService: UserService,
        private modalService: ModalService,
        private localizationService: LocalizationService,
        private addOnService: AddOnViewService,
        private standardsService: StandardsService
    ) {}

    public ngOnInit() {
        this.isUserLoggedIn = this.userService.isLoggedIn()
        this.isUserLocalized = this.localizationService.isLocalized()
        if (this.standardsInformation) {
            this.primaryStateStandardsName = this.standardsInformation.primaryStateStandardsName
            this.secondaryStateStandardsName = this.standardsInformation.secondaryStateStandardsName
            this.nationalStandards = this.transformStandardsGroup(
                this.standardsInformation.nationalStandards,
                "nationalStandards"
            )
            this.primaryStateStandards = this.transformStandardsGroup(
                this.standardsInformation.primaryStateStandards,
                "primaryStateStandards"
            )
            this.secondaryStateStandards = this.transformStandardsGroup(
                this.standardsInformation.secondaryStateStandards,
                "secondaryStateStandards"
            )

            this.hasStateStandards =
                this.primaryStateStandards.length > 0 || this.secondaryStateStandards.length > 0
        }

        this.subscriptions.push(
            this.localizationService.localizeData.subscribe((response) => {
                if (response && response.stateStandards) {
                    this.stateStandards = response.stateStandards
                }
            })
        )
    }

    public transformStandardsGroup(standardsGroup, standardType) {
        if (!standardsGroup) {
            return []
        }
        return Object.keys(standardsGroup).map((name, index) => {
            return {
                length: standardsGroup[name].length,
                name,
                type: standardType,
                standards: this.standardsService.groupByGrades(
                    standardsGroup[name],
                    this.addOnService.isAddonView
                ),
            }
        })
    }

    public openLoginModal() {
        this.modalService.open(AuthModalComponent)
    }

    public openLocalizationModal() {
        this.modalService.open(LocalizationModalComponent, {
            size: "lg",
            windowClass: "change-station-modal",
            data: {
                selectedStandardsTab: true,
            },
        })
    }

    public displayStandards(state: boolean, standard: any, targetGrades: string) {
        let { type, name } = standard
        for (let i = 0; i < this[type].length; i++) {
            if (this[type][i].name === name) {
                this[type][i].standards.forEach((element) => {
                    for (let key = 0; key < element.length; key++) {
                        if (key !== 0 && element[key].grade_bands === targetGrades) {
                            element[key].expanded = !!state
                        }
                    }
                })
            }
        }
    }

    public ngOnDestroy() {
        this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe())
    }
}
